"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Selectors = /** @class */ (function () {
    function Selectors() {
        this.handle = '';
        Object.seal(this);
    }
    return Selectors;
}());
exports.default = Selectors;
//# sourceMappingURL=Selectors.js.map